import { get } from "lodash";

import { TAX_VISIBILITY_HIDDEN, TAX_VISIBILITY_MESSAGE_ONLY } from '~/constants/shop'
import { ACCOUNTS_DISABLED, ACCOUNTS_REQUIRED, ACCOUNTS_OPTIONAL } from "~/constants/checkout-settings";

export const getShowShipping = (cart) => {
  return get(cart, 'shipping_method', false) && get(cart, 'shipping_price', false);
};

export const getShowTaxNotice = (shop) => {
  return get(shop, 'checkout_settings.tax_visibility', TAX_VISIBILITY_HIDDEN) === TAX_VISIBILITY_MESSAGE_ONLY;
};

export const getShowDiscount = (cart) => {
  return get(cart, 'discount_amount.amount', 0) > 0;
};

export const getShowServiceFee = (cart) => {
  return get(cart, 'service_fee.amount', 0) > 0;
};

export const getAccountsEnabled = (shop) => {
  const accountSetting = get(shop, 'checkout_settings.accounts', ACCOUNTS_DISABLED)
  return (accountSetting === ACCOUNTS_OPTIONAL || accountSetting === ACCOUNTS_REQUIRED);
}